const RECORDING = {
    BASE: 'Recording',
    DETAIL: undefined,
    PUBLIC: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined,
        MYEVENTS: undefined,
        TOKEN: undefined,

    },
    ADMIN: {
        _BASE: undefined,
        EVENTS: undefined,
        INTERVAL: undefined,
        PERMISSION: undefined,
        EMAILS:undefined,
    },
    ADMINEVENTS: {
        _BASE: undefined,
        EVENTS: undefined,
        DETAIL: undefined,
        TOKEN: undefined,
    },
};

RECORDING.PUBLIC._BASE = `${RECORDING.BASE}|Public`
RECORDING.PUBLIC.DETAIL = `${RECORDING.PUBLIC._BASE}|Events`
RECORDING.PUBLIC.MYEVENTS = `${RECORDING.PUBLIC._BASE}|Myevents`
RECORDING.PUBLIC.TOKEN = `${RECORDING.PUBLIC._BASE}|Token`

RECORDING.ADMIN._BASE = `${RECORDING.BASE}|Admin`
RECORDING.ADMIN.EVENTS = `${RECORDING.ADMIN._BASE}|Events`
RECORDING.ADMIN.INTERVAL = `${RECORDING.ADMIN._BASE}|Interval`
RECORDING.ADMIN.PERMISSION = `${RECORDING.ADMIN._BASE}|Permission`
RECORDING.ADMIN.EMAILS = `${RECORDING.ADMIN._BASE}|Emails`

RECORDING.ADMINEVENTS._BASE = `${RECORDING.ADMIN._BASE}|Event`
RECORDING.ADMINEVENTS.EVENTS = `${RECORDING.ADMINEVENTS._BASE}|Events`
RECORDING.ADMINEVENTS.DETAIL = `${RECORDING.ADMINEVENTS._BASE}|Detail`
RECORDING.ADMINEVENTS.TOKEN= `${RECORDING.ADMINEVENTS._BASE}|Token`

export default {
    ...RECORDING
}
